(function () {
  'use strict';

  class HairTypesSlider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-slider-track]');
      this.prev  = root.querySelector('[data-slider-prev]');
      this.next  = root.querySelector('[data-slider-next]');

      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.scrollByStep(-1));
      this.next.addEventListener('click', () => this.scrollByStep(1));
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons(), { passive: true });

      this.updateButtons();
    }

    getStep() {
      const firstCard = this.track.querySelector('.omi-hts__card, .omi-hts__intro-slide');
      if (!firstCard) return this.track.clientWidth;
      const cardWidth = firstCard.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      return cardWidth + gap;
    }

    scrollByStep(direction) {
      this.track.scrollBy({ left: direction * this.getStep(), behavior: 'smooth' });
    }

    updateButtons() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      const atStart = x <= 1;
      const atEnd   = x >= maxScroll - 1;
      this.prev.disabled = atStart;
      this.next.disabled = atEnd || maxScroll <= 0;
    }
  }

  function init() {
    document.querySelectorAll('[data-slider]:not([data-slider-ready])').forEach((el) => {
      el.setAttribute('data-slider-ready', '');
      new HairTypesSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const slider = e.target.querySelector('[data-slider]');
    if (slider && !slider.hasAttribute('data-slider-ready')) {
      slider.setAttribute('data-slider-ready', '');
      new HairTypesSlider(slider);
    }
  });
})();
